import { render, staticRenderFns } from "./safeSetting.vue?vue&type=template&id=0c795ab5&"
import script from "./safeSetting.vue?vue&type=script&lang=js&"
export * from "./safeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports